export const viewStates = {
    loading: 1,
    welcome: 2,
    showInstructions: 3,
    showQuestion: 4,
    assessmentCompleted: 5,
    sectionLanding: 6,
    alreadyCompleted: 7
};


